<script lang="ts">
    import type { Readable } from "svelte/store";
    import type { ChatMessageContent } from "../../../Connection/ChatConnection";

    export let content: Readable<ChatMessageContent>;
</script>

{#if $content.url !== undefined}
    <!-- svelte-ignore a11y-media-has-caption -->
    <video controls class="w-full block rounded">
        <source src={$content.url} />
    </video>
{:else if $content.rawUrl}
    <div class="p-3 text-xs text-white/70">Loading video...</div>
{:else}
    <div class="p-3 text-xs text-white/50">Video unavailable</div>
{/if}
